export type DeeplinkMessageTarget =
  | 'home'
  | 'showmen'
  | 'showMan'
  | 'show'
  | 'program'
  | 'sponsors'
  | 'practicalInfos'
  | 'practicalInfo'
  | 'map'
  | 'gallery'
  | 'notifications'
  | 'webview'
  | 'extern'
  | 'chat'
  | 'weezevent'

/**
 * Matches `scheme://target?params`. The scheme is the festival env, which may contain
 * a hyphen (magic-odyssey, foire-de-clermont...), hence [\w-] and not \w.
 */
export const DEEPLINK_PATTERN = /^([\w-]+):\/\/(\w+)\?*(.*)*$/i

export const parseDeeplink = (deeplink: string): { target: DeeplinkMessageTarget; paramsAsMap: { [key: string]: string } } => {
  const deeplinkPattern = DEEPLINK_PATTERN
  const [, , target, params] = deeplinkPattern.exec(deeplink) ?? []
  const paramsAsMap = params
    ? params.split('&').reduce((acc: { [key: string]: string }, param: string) => {
        const [key, value] = param.split('=')
        acc[key] = value
        return acc
      }, {})
    : {}
  return { target: target as DeeplinkMessageTarget, paramsAsMap }
}
